import { SplitUrlContext } from "./SplitUrlContext"
import Workspace from "../../core/internal/workspace/Workspace"
import { SplitUrlMatcher } from "./SplitUrlMatcher"
import HackleCore from "../../core/HackleCore"
import { SplitUrlRedirectedCookieStorage } from "./SplitUrlRedirectedCookieStorage"
import { Experiment, HackleUser } from "../../core/internal/model/model"

export interface SplitUrlDeterminer {
  determineOrNull(user: HackleUser): SplitUrlContext | null
}

export abstract class AbstractSplitUrlDeterminer<W extends Workspace, E extends Experiment>
  implements SplitUrlDeterminer {
  constructor(
    private readonly splitUrlMatcher: SplitUrlMatcher,
    private readonly splitUrlRedirectedCookieStorage: SplitUrlRedirectedCookieStorage,
    private readonly core: HackleCore
  ) {}

  protected abstract workspace(user: HackleUser): W | null

  protected abstract splitUrlExperiments(workspace: W): E[]

  determineOrNull(user: HackleUser): SplitUrlContext | null {
    if (this.splitUrlRedirectedCookieStorage.alreadyRedirected()) {
      this.splitUrlRedirectedCookieStorage.clear()
      return null
    }

    const workspace = this.workspace(user)
    if (!workspace) return null

    for (const experiment of this.splitUrlExperiments(workspace)) {
      const isMatch = this.splitUrlMatcher.matches(workspace, experiment, user)
      if (isMatch) {
        const decision = this.core.experiment(experiment.key, user)
        return new SplitUrlContext(workspace, experiment, decision, user)
      }
    }

    return null
  }
}
